import { useMemo } from 'react';
import type { BaseShow, ShowFilter } from '@/types';
import { getShowParam } from '@/utils';
import { PrefixedSelect, SelectOption } from '../PrefixedSelect';

type ShowFilterProps = {
  shows: BaseShow[];
  selectedShow: ShowFilter;
  onApply: (selectedShow: ShowFilter) => void;
  onOpen?: () => void;
  renderAllShows?: boolean;
};

const ShowFilter = ({
  shows = [],
  selectedShow,
  onApply,
  onOpen,
  renderAllShows = true,
}: ShowFilterProps) => {
  const handleApply = (selectedShow: ShowFilter) => {
    onApply(selectedShow);
  };

  const handleOpen = () => {
    onOpen?.();
  };

  const displayLabel = useMemo(() => {
    const param = getShowParam(selectedShow);
    if (param === 'all') return 'Show: All';
    const match = shows.find((s) => s.id === param);
    return match ? `Show: ${match.name}` : 'Select a show';
  }, [selectedShow, shows]);

  return (
    <PrefixedSelect
      data-testid="show-select"
      displayLabel={displayLabel}
      placeholder="Shows"
      value={getShowParam(selectedShow)}
      onClick={handleOpen}
      onChange={(event) => {
        const selectedValue = (event.target as HTMLSelectElement).value;
        const selectedShow: ShowFilter =
          selectedValue === 'all'
            ? 'all'
            : shows.find((show) => show.id === selectedValue)
              ? selectedValue
              : undefined;

        handleApply(selectedShow);
      }}
    >
      {renderAllShows && <SelectOption value="all">All</SelectOption>}
      {shows?.length > 0 &&
        shows.map((show) => (
          <SelectOption key={show.id} value={show.id}>
            {show.name}
          </SelectOption>
        ))}
    </PrefixedSelect>
  );
};

export default ShowFilter;
